import { render, staticRenderFns } from "./DownloadSideBar.vue?vue&type=template&id=3a2000e1&scoped=true"
import script from "./DownloadSideBar.vue?vue&type=script&lang=js"
export * from "./DownloadSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2000e1",
  null
  
)

export default component.exports